import React from "react";

interface DashboardLabelProp {
  position: string;
  onClick: () => void;
}

const LargeAdBanner: React.FC<DashboardLabelProp> = ({ position, onClick }) => {
  return (
    <div className="banner">
        <span onClick={onClick} style={{cursor:"grab"}}>
            <img className={`w-100 ${position === "top"?"banner_top":"banner_bottom"}`} alt="" />
          </span>
    </div>
  );
};
export default LargeAdBanner;
